module.exports = __webpack_public_path__ + "img/自由平面.07d02c7d.png";